
export const QR = "qr";
export const EMAIL = "email";
export const WUNDERMAN_THOMPSON = "wt";
